import IGeoCoordinate from "./IGeoCoordinate";

export default class Shape {
    constructor(points: IGeoCoordinate[]) {
        this.points = points;
    }

    points: IGeoCoordinate[];
}